<template>
  <b-table class="line-height" :empty-text="'ไม่พบข้อมูล'" :show-empty="items === null || items === undefined || (items && items.length === 0)
    " :striped="true" :bordered="true" v-bind:items="items" v-bind:fields="fields">
    <!-- <template v-slot:cell(index)="data">
      {{ (data.index + 1) | number }}
    </template> -->
    <template #head(selectCheckbox)="data">
      <b-form-checkbox @click.native.stop v-model="isSelectAll" @change="onSelectAll($event)"
        :disabled="isDisabled"></b-form-checkbox>
    </template>
    <template v-slot:cell(selectCheckbox)="data">
      <b-form-checkbox @click.native.stop @change="onSelectCheckbox($event, data.item)" v-model="data.item.checkbox"
        :disabled="isDisabled"></b-form-checkbox>
    </template>
  </b-table>
</template>
<script>
import { FormatQty } from '@/helpers/utils/format-qty.js'
import paymentService from '@/helpers/service/payment-service'
import { eventBus } from '@/main.js'

export default {
  name: 'TableSelectPayment',
  props: {
    value: {
      type: Array,
      default: () => {
        return this.items
      },
    },
    vendor_type: {
      type: String,
      default: () => {
        return ''
      },
    },
    isDisabled: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    isSetDefualt: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    business_unit: {
      type: Array,
      default: () => {
        return []
      },
    },
    product_status: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'selectCheckbox',
          label: '',
          class: 'text-center',
          thClass: 'w-30-px',
          sortable: false,
        },
        // {
        //   key: 'index',
        //   formatter: (value, key, item) => {
        //     return FormatQty(value ? value : 0)
        //   },
        //   label: '#',
        //   thClass: 'w-50-px',
        //   tdClass: 'text-center',
        //   sortable: false,
        // },
        {
          key: 'display_name.th',
          label: 'การชำระเงินที่รองรับ (ไทย)',
          thClass: '',
          tdClass: '',
          sortable: false,
        },
        {
          key: 'display_name.en',
          label: 'การชำระเงินที่รองรับ (อังกฤษ)',
          thClass: '',
          tdClass: '',
          sortable: false,
        },
      ],
      items: [],
      isSelectAll: false,
      isFirstWatchValue: true,
      timerCount: 3,
      isUseEventBus: false,
      field_Change: {},
      isUserSelect: false,
    }
  },
  watch: {
    value: {
      handler(val) {
        if (this.isFirstWatchValue) {
          this.onGetPaymentAsync()
        }
      },
      deep: true,
    },
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--
            // console.log(this.timerCount)
          }, 1000)
        } else {
          this.isUseEventBus = true
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
    vendor_type: {
      handler: function (val) {
        // if (this.items && this.items.length > 0 && (this.timerCount === 0 || !this.items.some(s => s.checkbox === true))) {
        //   if (val == 'OFMStock') {
        //     this.items.forEach(el => {
        //       if(this.isSetDefualt){
        //         if (
        //           el.display_name.en == 'PayOnDelivery' ||
        //           el.display_name.en == 'FullPayment' ||
        //           el.display_name.en == 'CreditTerm'
        //         ) {
        //           el.checkbox = true
        //         } else {
        //           el.checkbox = false
        //         }
        //       }
        //     })
        //   } else if (val == 'DropShip') {
        //     this.items.forEach(el => {
        //       if(this.isSetDefualt){
        //         if (
        //           el.display_name.en == 'FullPayment' ||
        //           el.display_name.en == 'CreditTerm'
        //         ) {
        //           el.checkbox = true
        //         } else {
        //           el.checkbox = false
        //         }
        //       }
        //     })
        //   }
        //   this.$nextTick(async () => {
        //     this.$emit(
        //       'input',
        //       this.items.filter(f => f.checkbox === true)
        //     )
        //   })
        // }
      },
      deep: true,
    },
    items: {
      handler: function (val) {
        this.$nextTick(() => {
          this.isSelectAll =
            val.filter(function (e) {
              return e.checkbox === true
            }).length === val.length
              ? true
              : false
        })
      },
      deep: true,
    },
    business_unit: {
      handler: function (newval, oldValue) {

        if (newval !== oldValue && !newval && !oldValue) {
          this.onDefualtPayment(this.field_Change)
        }

      },
      deep: true,
    },
    product_status: {
      handler: function (newval, oldValue) {

        if (newval !== oldValue && !newval && !oldValue) {
          this.onDefualtPayment(this.field_Change)
        }

      },
      deep: true,
    },
  },
  created() {
    eventBus.$on('onSetDefault', fieldChange => {
      this.field_Change = fieldChange
      console.log("isFirstLoad onSetDefault", fieldChange)
      if (this.isUseEventBus) {
        console.log("isFirstLoad payment", fieldChange)
        if (fieldChange.type === 'Product Type') {
          this.onDefualtPayment(fieldChange)
        }
      }
    })
  },
  async mounted() {
    this.$nextTick(async () => {
      await this.onGetPaymentAsync()
      console.log("items", this.items)
    })
  },
  methods: {
    onDefualtPayment(fieldChange) {
      console.log("onDefualtPayment", this.vendor_type, this.product_status, this.business_unit, this.value)
      if (this.isUserSelect) {
        return;
      }
      if (this.business_unit.some(w => w == "B2S")) {
        if (this.vendor_type == 'OFMStock') {
          this.items.forEach(el => {
            el.checkbox = false
            if (this.product_status != "PreOrder" && el.display_name.en != "CreditTerm") {
              el.checkbox = true
            }
            else if (el.display_name.en == 'FullPayment' || el.display_name.en == 'Redemption') {
              el.checkbox = true
            }
          })
        } else if (this.vendor_type == 'DropShip') {
          this.items.forEach(el => {
            el.checkbox = false
            if (this.product_status != "PreOrder" && el.display_name.en != "PayOnDelivery" && el.display_name.en != "CreditTerm") {
              el.checkbox = true
            } else if (el.display_name.en == 'FullPayment' || el.display_name.en == 'Redemption') {
              el.checkbox = true
            }
          })
        }
      } else {
        if (this.vendor_type == 'OFMStock') {
          this.items.forEach(el => {
            el.checkbox = false
            if (this.product_status != "PreOrder") {
              el.checkbox = true
            }
            else if (el.display_name.en == 'FullPayment' || el.display_name.en == 'Redemption') {
              el.checkbox = true
            }
          })
        } else if (this.vendor_type == 'DropShip') {
          this.items.forEach(el => {
            el.checkbox = false
            if (this.product_status != "PreOrder" && el.display_name.en != "PayOnDelivery" && el.display_name.en != "CreditTerm") {
              el.checkbox = true
            } else if (el.display_name.en == 'FullPayment' || el.display_name.en == 'Redemption') {
              el.checkbox = true
            }
          })
        }
      }
      this.$nextTick(async () => {
        this.$emit(
          'input',
          this.items.filter(f => f.checkbox === true)
        )
      })
    },
    onSelectAll(value) {
      this.items.forEach(async element => {
        element.checkbox = value
      })
      this.$emit(
        'input',
        this.items.filter(function (e) {
          return e.checkbox === true
        })
      )
    },
    onSelectCheckbox(value, object) {
      this.isUserSelect = true
      if (!this.items.some(w => w.checkbox === true)) {
        this.isUserSelect = false
      }
      this.$nextTick(() => {
        this.items[object.index].checkbox = value
        this.$emit(
          'input',
          this.items.filter(function (e) {
            return e.checkbox === true
          })
        )
      })
    },
    async onGetPaymentAsync() {
      console.log("isFirstLoad onGetPaymentAsync")
      let params = new URLSearchParams()
      params.append('sort', '_id')
      let result = await paymentService.getPaymentMasterListAsync(params)
      if (result.status === 200) {
        //Checkbox ตาม value ที่ props เข้ามา
        let selectedItems =
          this.value && this.value.length > 0 ? this.value.map(m => m.id) : []
        console.log("isFirstLoad selectedItems", selectedItems)
        let paymentItems = []
        result.data.items.forEach((element, index) => {
          paymentItems[index] = {
            checkbox: selectedItems.some(s => s == element.id) ? true : false,
            index: index,
            id: element.id,
            payment_group: element.payment_group,
            display_name: {
              en: element.display_name.en,
              th: element.display_name.th,
            },
            payments: element.payments,
          }
        })
        this.items = paymentItems
        if (selectedItems.length > 0) {
          this.isFirstWatchValue = false
        }
      } else {
        console.log('error', result.response.data.message)
      }
    },
  },
}
</script>
